import React from "react";
import { useNavigate } from "react-router-dom"; // ✅ add this
import "./card.css";

const Card = ({ image, title, description, id }) => {
  const navigate = useNavigate(); // ✅ create navigator

  return (
    <div className="product-card">

      <div className="product-top">
        <img src={image} alt={title} className="product-img" />
      </div>

      <div className="product-content">
        <h3 className="card-title">{title}</h3>

        <div className="product-tags">
          <span>NEW</span>
          <span>POPULAR</span>
        </div>

        <p className="product-desc">{description}</p>

        <div className="product-actions">
          <button className="btn-primary pButton">Get Quote</button>

          {/* ✅ Navigation added */}
          <button
            className="btn-secondary sButton"
            onClick={() => navigate(`/product/${id}`)}
          >
            Details
          </button>
        </div>
      </div>

    </div>
  );
};

export default Card;